import { createIcon } from './createIcon'

export const CheckIcon = createIcon({
  displayName: 'CheckIcon',
  viewBox: '0 0 15 12',
  path: [
    <path
      d="M5.101 11.6568L0.151001 6.70677L1.565 5.29277L5.1025 8.82627L5.101 8.82777L13.586 0.342773L15 1.75677L6.515 10.2428L5.102 11.6558L5.101 11.6568Z"
      fill="currentColor"
    />,
  ],
})
